document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const checkbox = document.getElementById("notice-approval");
    const checkoutButton = document.querySelector('button[name="checkout"]');
    const paypalDiv = document.querySelector("#dynamic-checkout-cart");

    // Initial state: disable both buttons
    if (checkoutButton) {
      checkoutButton.setAttribute("disabled", "");
    }
    if (paypalDiv) {
      paypalDiv.style.pointerEvents = "none";
      paypalDiv.style.opacity = "0.5"; // Visual feedback for disabled state
    }

    // Toggle buttons with a 3-second delay based on checkbox state
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        if (checkoutButton) {
          checkoutButton.removeAttribute("disabled");
        }
        if (paypalDiv) {
          paypalDiv.style.pointerEvents = "auto";
          paypalDiv.style.opacity = "1"; // Restore full opacity when enabled
        }
      } else {
        if (checkoutButton) {
          checkoutButton.setAttribute("disabled", "");
        }
        if (paypalDiv) {
          paypalDiv.style.pointerEvents = "none";
          paypalDiv.style.opacity = "0.5"; // Dim the PayPal button when disabled
        }
      }
    });
  }, 2000); 
});
